import React, {useMemo} from 'react';
import moment from 'moment';
import {Table} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import {shortDate} from '../../../common/constants/datesFormat';
import TablePaginator from '../common/TablePaginator';

const columnsTable = [
  {
    'Header': 'NÚMERO CAMPAÑA',
    'accessor': 'campaingNo',
  },
  {
    'Header': 'NOMBRE CAMPAÑA',
    'accessor': 'campaingName',
  },
  {
    'Header': 'CHASIS',
    'accessor': 'chassis',
  },
  {
    'Header': 'CONCESIONARIO ASIGNADO',
    'accessor': 'asignedDealer',
    'Cell': ({row}) => row.original.asignedDealer.toUpperCase(),
  },
  {
    'Header': 'NÚMERO GARANTÍA',
    'accessor': 'numTwc',
  },
  {
    'Header': 'ESTADO TWC',
    'accessor': 'status',
  },
  {
    'Header': 'CONCESIONARIO ATENDIDO',
    'accessor': 'attendedDealer',
  },
  {
    'Header': 'FECHA DEL TWC',
    'accessor': 'dateTwc',
    'Cell': ({row}) => {
      const {dateTwc} = row.original;
      return dateTwc ? moment(dateTwc).format(shortDate) : null;
    },
  },
  {
    'Header': 'CÓDIGO DE TAREA',
    'accessor': 'taskId',
  },
];


const WarrantiesCampaignTable = ({dataTable}) => {
  const data = useMemo(() => dataTable, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
  );

  return (
    <>
      <div className='table-container'>
        <Table
          className='interactive'
          striped
          {...getTableProps()}
        >
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    textAlign='center'
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell, j) => {
                      return (
                        <Table.Cell
                          key={j}
                          textAlign='center'
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default WarrantiesCampaignTable;
